import { Component, OnInit } from '@angular/core';
import { Faq } from '@hm_app/@core/models/info';
import * as _ from 'lodash-es';

@Component({
  selector: 'ngx-glossario-faq',
  templateUrl: './glossario-faq.component.html',
  styleUrls: ['./glossario-faq.component.scss'],
})
export class GlossarioFaqComponent implements OnInit {

  alphabets: any[];
  _faqs: Faq[];
  filtered_faqs: Faq[];

  selected_letter: string;

  constructor() { }

  ngOnInit() {
    this.alphabets = [];
    this.getAlphabetLetters();
  }

  set faqs(f: Faq[]) {
    this._faqs = f;
    this._faqs = _.sortBy(this._faqs, 'domanda.it');
    this.filtered_faqs = this._faqs;
  }
  get faqs(): Faq[] {
    return this._faqs;
  }

  getAlphabetLetters() {
    for (let i = 65; i <= 90; i++) {
      this.alphabets.push(String.fromCharCode(i));
    }
  }

  filterFaqs(l: string) {
    this.selected_letter = l;
    this.filtered_faqs = _.filter(this.faqs, function (f) {
      if (f.domanda.it.startsWith(l)) {
        return f;
      }
    });
  }

  glossarioFaqs(g: string) {
    this.selected_letter = g;
    this.filtered_faqs = _.filter(this.faqs, function (f) {
      if (f.glossario.it == g) {
        return f;
      }
    });
  }

}
